import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { Brand } from '@features/brand/interfaces/brand.interface';
import { Category } from '@features/category/interfaces/category.interface';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';

@Component({
  selector: 'fc-product-filter',
  templateUrl: './product-filter.component.html',
  styleUrls: ['./product-filter.component.css'],
})
export class ProductFilterComponent implements OnInit, OnDestroy, OnChanges {
  private readonly destroy$ = new Subject<void>();
  // Declare icons
  faChevronDown = faChevronDown;
  faFilter = faFilter;

  sale: boolean = false;
  showCategory: boolean = true;
  showBrand: boolean = true;
  showPrice: boolean = true;

  @Output() setSaleFilter: EventEmitter<any> = new EventEmitter<any>();
  // brands
  @Output() setBrandFilter: EventEmitter<any> = new EventEmitter();
  @Input() selectedBrandIds: any = [];
  @Input() brands: Brand[] = [];

  // categories
  @Output() setCategoryFilter: EventEmitter<any> = new EventEmitter();
  @Input() selectedCategorySlugs: any = [];
  @Input() categories: Category[] = [];

  // price
  @Output() setPriceFilter: EventEmitter<any> = new EventEmitter();
  @Input() selectedPriceRange: {
    minPrice: number | null;
    maxPrice: number | null;
  } = {
    minPrice: null,
    maxPrice: null,
  };
  minPriceInput: number | null = null;
  maxPriceInput: number | null = null;
  priceInputInterval: any = null;
  quickPrices = [
    // note: currency need dynamic symbol
    { minPrice: 50000, maxPrice: 250000, label: 'Rp50 rb - Rp250 rb' },
    { minPrice: 250000, maxPrice: 500000, label: 'Rp250 rb - Rp500 rb' },
    { minPrice: 500000, maxPrice: 1000000, label: 'Rp500 rb - Rp1 jt' },
  ];
  //

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {}
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnChanges() {
    if (this.selectedPriceRange.minPrice || this.selectedPriceRange.maxPrice) {
      this.minPriceInput = this.selectedPriceRange.minPrice;
      this.maxPriceInput = this.selectedPriceRange.maxPrice;
    }
  }

  // manage category filter
  setSelectedCategory(
    category1: string,
    category2: string = '',
    category3: string = ''
  ) {
    let categorySlugs: any = [category1];
    if (category2) categorySlugs.push(category2);
    if (category3) categorySlugs.push(category3);
    if (categorySlugs) {
      this.selectedCategorySlugs = categorySlugs;
      this.setCategoryFilter.emit({
        slugs: this.selectedCategorySlugs,
      });
    }
  }

  onSaleFilter() {
    this.sale = !this.sale;
    this.setSaleFilter.emit({ sale: this.sale });
  }

  // manage brand filter
  checkedBrand(brand: Brand): Boolean {
    if (
      this.selectedBrandIds.some(
        (selectedBrand: Brand) => selectedBrand.id === brand.id
      )
    ) {
      return true;
    }
    return false;
  }
  onSelectBrand(brand: Brand) {
    if (
      this.selectedBrandIds.some(
        (selectedBrand: Brand) => selectedBrand.id === brand.id
      )
    ) {
      this.selectedBrandIds = this.selectedBrandIds.filter(
        (selectedBrand: Brand) => selectedBrand.id != brand.id
      );
    } else {
      this.selectedBrandIds.push({ id: brand.id });
    }
    this.setBrandFilter.emit(this.selectedBrandIds);
  }

  // manage price filter
  onInputPrice() {
    if (isPlatformBrowser(this.platformId)) {
      clearInterval(this.priceInputInterval);
      this.priceInputInterval = setInterval(() => {
        if (this.minPriceInput == 0) this.minPriceInput = null;
        if (this.maxPriceInput == 0) this.maxPriceInput = null;
        this.selectedPriceRange = {
          minPrice: this.minPriceInput ? Number(this.minPriceInput) : null,
          maxPrice: this.maxPriceInput ? Number(this.maxPriceInput) : null,
        };
        this.setPriceFilter.emit(this.selectedPriceRange);
        clearInterval(this.priceInputInterval);
      }, 1000);
    }
  }
  onQuickPrice(minPrice: number, maxPrice: number) {
    if (this.minPriceInput == minPrice && this.maxPriceInput == maxPrice) {
      this.minPriceInput = null;
      this.maxPriceInput = null;
    } else {
      this.minPriceInput = minPrice;
      this.maxPriceInput = maxPrice;
    }
    this.selectedPriceRange = {
      minPrice: this.minPriceInput,
      maxPrice: this.maxPriceInput,
    };
    this.setPriceFilter.emit(this.selectedPriceRange);
  }
  onRemoveMinPrice() {
    this.minPriceInput = null;
    this.selectedPriceRange.minPrice = null;
    this.setPriceFilter.emit(this.selectedPriceRange);
  }
  onRemoveMaxPrice() {
    this.maxPriceInput = null;
    this.selectedPriceRange.maxPrice = null;
    this.setPriceFilter.emit(this.selectedPriceRange);
  }
  onRemoveAllFilter() {
    this.minPriceInput = null;
    this.maxPriceInput = null;
    this.selectedPriceRange = {
      minPrice: null,
      maxPrice: null,
    };
  }
}
